import { createRouter } from '@tanstack/react-router';
import type { QueryClient } from '@tanstack/react-query';
import { routeTree } from './routeTree.gen';
import { NotFound } from './not-found';

/**
 * Create the typed router. The query client is passed as router context so
 * route loaders can call `ensureQueryData` to prefetch server state.
 */
export function createAppRouter(queryClient: QueryClient) {
  return createRouter({
    routeTree,
    context: { queryClient },
    defaultPreload: 'intent',
    // Query owns server-state caching; the router should not also cache loaders.
    defaultPreloadStaleTime: 0,
    // Page transitions disabled.
    defaultViewTransition: false,
    scrollRestoration: true,
    defaultNotFoundComponent: NotFound,
  });
}

// Register the router type for end-to-end inference across the app.
declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof createAppRouter>;
  }
}
